import React, { useLayoutEffect, useState } from 'react';
import styles from '../../styles/redeem/redeemForm.module.css';
import { subscribeRedeemCoins } from '../../ApiCalls/Redeem/api_v1_redeem';
import check from "../../images/v1/redeem/check.svg";
import { useTranslation } from 'react-i18next';

function SubscribeConsentForm() {
    const { t } = useTranslation();
    const [btnDisabled, setBtnDisabled] = useState(false);
    const [btnValue, setBtnValue] = useState(t('subscribe'));
    const [subscribed, setSubscribed] = useState(false);
    const [subscribeFailed, setsubscribeFailed] = useState(false);
    const [subscribeFailedMsg, setsubscribeFailedMsg] = useState(false);
    useLayoutEffect(() => {
        // document.body.style.backgroundColor = "#f8b600";
        document.querySelector("meta[name='theme-color']").setAttribute("content", "#f8b600");
    }, []);
    async function handleSubscribe() {
        setBtnValue(t('please_wait_moment'));
        setBtnDisabled(true);
        try {

            const res = await subscribeRedeemCoins();
            const resp = res.data.data;
            if (resp.suv === 1) {
                setSubscribed(true)
            } else {
                setSubscribed(false)
            }
        } catch (e) {
            setsubscribeFailed(true);
            setsubscribeFailedMsg(e.response.data.message);
            setTimeout(() => {   // ***
                setsubscribeFailed(false);
                setsubscribeFailedMsg(null);
                setBtnValue(t('subscribe'));
                setBtnDisabled(false);
            }, 15000);
        }

    }

    function handleRedirectRedeem() {
        window.location.reload();
    }
    return (
        <main className={styles.mainContainerRed}>

            <section className={`${styles.insufficentCoins} ` + (subscribeFailed ? `${styles.show}` : `${styles.hidden}`)}>
                <p style={{ padding: "5px" }}>{subscribeFailedMsg}</p>
            </section>
            {!subscribed ?
                <section className={styles.formSection}>
                    <h3 className={styles.formSectionh3}>{t('dear_user')}</h3>
                    <p className={styles.formSectionp1}>{t('free_trial_message')}</p>
                    <button type="button" className={styles.RedeemFormBtn} disabled={btnDisabled} onClick={handleSubscribe}>{btnValue}</button>
                </section>
                :
                <section className={styles.formSection} style={{ alignItems: "center" }}>
                    <img src={check} alt="loading ..." style={{ width: "100px", height: "100px", minHeight: "100px" }} />
                    <h3 className={styles.formSectionh3}>{t('congratulations')}</h3>
                    <p className={styles.formSectionp1}>{t('redeem_coins_now')}</p>
                    <button type="button" className={styles.RedeemFormBtn} onClick={handleRedirectRedeem}>{t('back_to_redeem')}</button>
                </section>
            }

        </main>
    )
}

export default SubscribeConsentForm;